import React from 'react';

type Props = {
    androidButton?: React.ReactNode;
    iosButton?: React.ReactNode;
};

function StoreButtons(props: Props) {
    const { androidButton, iosButton } = props;

    return (
        <div className="store-buttons">
            <div className="store-buttons__item store-buttons__item--android">{androidButton}</div>
            <div className="store-buttons__item store-buttons__item--ios"> {iosButton} </div>
        </div>
    );
}

export default StoreButtons;
